<template>
  <section id="sso" style="height: 100vh; display: flex; justify-content: center; align-items: center;">
    인증중입니다.
  </section>
</template>
<script>
import Util from '@/util';
import base64 from 'base64-js';
// import crypto from 'crypto-js';

export default {
  data () {
    return {
      loading: true,
      error: null,
    };
  },
  mounted () {
    this.loading = false;
    let isMb = this.getURLParameter('isMb');
    if (isMb === 'mb') {
      this.login();
    } else {
      this.agentCheck();
    }
    this.agentCheck();
  },
  methods: {
    async agentCheck () {
      let sk = decodeURI(decodeURIComponent(this.getURLParameter('sk')));
      let meetingKey = this.getURLParameter('meetingKey');
      let params = {
        isSet: 'isSet',
      };

      if (sk !== 'undefined') {
        let json = { sk: sk };
        let response = (await this.$http.post('/api/auth/getMbSettingUrl', json));
        if (response.data.user.status === 'r') {
          window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
          this.loading = false;
          return;
        }

        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);

        this.$cookies.set('token', response.data.token, 60 * 60 * 9);
        this.$http.defaults.headers.common['Authorization'] =
          'Bearer ' + response.data.token;

        this.$router.replace(`/reserveDialog?meetingKey=${meetingKey}`);

        return false;
      }
      
      // get redirect url
      let redirectUrl = (await this.$http.get('/api/auth/sso/redirecturl', { params: params })).data.redirectUrl;
      let ssoStatus = (await this.$http.get('/api/auth/sso/status')).data.ssoStatus;
      redirectUrl = `${redirectUrl}?meetingKey=${meetingKey}`;
      this.$bandiJS.agent.init({isDebug: true});
      this.$bandiJS.agent.call({requestType:'alive'});
      this.$bandiJS.agent.call({
        requestType: 'check_login',
        isShownLoginForm: 'false',
        successCallback: async function(response) {
          //if(response && response['success']) {
          if( response && response['success'] && response.dataMap && response.dataMap['is_login']) {
            var pSid = response.dataMap['p_sid'];

            console.log(`response`, response);
            
            // pid로 ssoLoginCheck 하는 부분
            let result = await Util.ssoLoginCheck(pSid, redirectUrl, ssoStatus);
            console.log(`result ::::: `, result);
            
            return;
          }
          
          alert("Agent에서 Login 해주세요!");
          window.close();
        }, 
        errorCallback: function(response) {
          console.log(`errorCallback`, response);

          if(response && 'agent.is.off' == response.error) {
            alert('SSO agent를 실행해 주세요!');
            // window.location.href = '/login';
          }            
        }
      });
      let paramUserKey = '';
      let userKey = '';
      if (this.getURLParameter('ukPk')) {
        // paramUserKey = decodeURIComponent(this.getURLParameter('ukPk')).replace(/\+/g, '%20');
        // userKey = atob(paramUserKey);
        userKey = this.getURLParameter('ukPk');
      }

      
    },
    async login () {
      let userKey = this.getURLParameter('userKey');

      if (userKey) {
        this.$http
          .post('/api/auth/ssoTbMbLogin', { userKey: userKey })
          .then((response) => {
            if (response.data.user.status === 'r') {
              window.getApp.$emit('APP_USER_LOGIN_REQUESTED');
              this.loading = false;
              return;
            }

            this.loginSuccess(response);
          })
          .catch((error) => {
            console.log(`##### error : `, error);
            this.loading = false;
            this.error = error.response.data.error;
          });
      }
    },

    async loginSuccess (response) {
      let meetingKey = this.getURLParameter('meetingKey');
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 60 * 60 * 9);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;

      this.$router.replace(`/reserveDialog?meetingKey=${meetingKey}`);
      this.loading = false;
    },
    getURLParameter (sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split('&');
      for (let i = 0; i < sURLVariables.length; i++) {
        let sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1];
        }
      }
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/CheckAgent.vue